<div class="flex w-full min-w-0 flex-col gap-4 px-2 pb-4">
  <div class="flex flex-wrap w-full items-center gap-4">
    <proffeo-task-status-select
      (statusSelected)="statusSelected.emit($event)"
      [mode]="TaskStatusSelectEnum.DOTS"
      [readonly]="false"
      [taskStatus]="task().status"
    />

    <proffeo-ui-slider
      (valueChange)="progressSelected.emit($event)"
      [value]="task().percentageOfProgress ?? 0"
      [displayWith]="formatPercent"
      class="w-[140px]"
    />

    <div class="flex flex-1 items-center gap-4">
      <proffeo-task-priority-select
        (prioritySelected)="prioritySelected.emit($event)"
        [readonly]="false"
        [small]="false"
        [taskPriority]="task().priority"
      />
      <div class="ml-auto flex items-center gap-2">
        <mat-icon
          (click)="openTimeReportRequested.emit()"
          fontIcon="play_circle"
          class="icon-lg icon-success shrink-0 cursor-pointer"
        />
        <proffeo-task-timer
          (click)="timeReportsTabRequested.emit()"
          [estimation]="$safeNavigationMigration(task().estimation?.time)"
          [mode]="taskTimerMode.readonly"
          [summaryTime]="$safeNavigationMigration(task().statistics?.summaryTime)"
          class="cursor-pointer"
        />
      </div>
    </div>
  </div>

  <div class="task-details-place-row">
    <proffeo-task-industry-select
      (industryClicked)="industryRequested.emit()"
      [isReadonly]="false"
      [projectIndustry]="task().projectIndustry()"
    />
    <proffeo-location-select
      (locationClicked)="locationRequested.emit()"
      [location]="task().location()"
      [small]="false"
    />
  </div>

  <div class="flex flex-wrap items-center gap-4">
    <proffeo-ui-date-picker-compact
      (valueChange)="startDateSelected.emit($event)"
      [max]="task().endDate"
      [touchUi]="false"
      [value]="task().startDate"
      fontIcon="calendar_check"
      placeholderKey="project-tasks.list.column-headers.start-date"
      class="flex min-w-0"
    />
    <proffeo-ui-date-picker-compact
      (valueChange)="endDateSelected.emit($event)"
      [min]="task().startDate"
      [touchUi]="false"
      [value]="task().endDate"
      fontIcon="calendar_add_on"
      placeholderKey="project-tasks.list.column-headers.end-date"
      class="flex min-w-0"
    />
  </div>

  <div class="flex min-w-0 flex-wrap items-center justify-between gap-4">
    <proffeo-task-estimation-select
      (estimationSelected)="estimationSelected.emit($event)"
      [estimation]="task().estimation"
      class="min-w-0 max-w-full flex gap-2"
    />
    <div class="flex flex-wrap items-center gap-1">
      @for (tag of tags(); track tag.id) {
        <proffeo-tag
          (click)="tagsRequested.emit()"
          [tag]="tag"
          class="cursor-pointer"
        />
      }
      @if (tags().length === 0) {
        <proffeo-tag
          (click)="tagsRequested.emit()"
          [tag]="'project-tags.add-project-tag' | translate"
          class="cursor-pointer"
        />
      }
    </div>
  </div>

  <div class="flex flex-wrap justify-between gap-4">
    <proffeo-ui-task-assignees
      (changeGroup)="groupRequested.emit()"
      (changeIndustry)="industryRequested.emit()"
      (changeUsers)="participantsRequested.emit()"
      [avatarSize]="AvatarSize.SM"
      [avatarsOverlapping]="false"
      [projectGroupAdmin]="task().projectGroupAdministrator()"
      [projectIndustry]="task().projectIndustry()"
      [taskUsers]="taskUsers()"
    />
  </div>

  <proffeo-task-acknowledgement-required-panel [task]="task()" />
</div>
